import { QueryClient } from '@tanstack/react-query'
import { isApiError } from '../api/types'

/** Network failures and 5xx get two retries. Nothing gets more. */
export const MAX_RETRIES = 2

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false
  if (!isApiError(error)) return false
  return error.failure.retryable
}

/** Exponential backoff, capped so a struggling API is not hammered. */
export function retryDelay(failureCount: number): number {
  return Math.min(1000 * 2 ** failureCount, 8000)
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        retryDelay,
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        throwOnError: false,
      },
      mutations: {
        retry: false,
      },
    },
  })
}

export const queryClient = createQueryClient()
